// Class component because React still has no hook for catching render errors.
// Uses translate(getLocale(), …) directly — a class can't call useT(), and a
// crashed subtree re-rendering on locale change is not worth wiring up.
import { Component, type ReactNode } from "react";
import { TriangleAlert } from "lucide-react";
import { getLocale, translate } from "../lib/i18n";
import { Button } from "@/components/ui/button";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      const locale = getLocale();
      return (
        <div className="mx-auto m-4 max-w-md rounded-xl border border-destructive/30 bg-destructive/10 p-6 text-center shadow-card dark:border-destructive/40">
          <TriangleAlert aria-hidden className="mx-auto mb-2 size-6 text-destructive" />
          <p className="mb-1 text-sm font-semibold text-destructive">{translate(locale, "error.somethingWrong")}</p>
          <p className="mb-4 break-words text-sm text-destructive/90">{this.state.error.message}</p>
          <Button type="button" onClick={() => window.location.reload()}>
            {translate(locale, "error.reload")}
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
